import defaultReducer from "./defaultReducer";

export default defaultReducer("SET_EFT", []);
